// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O86b","name":"styles_name__2KHJ3","phone":"styles_phone__1ictB"};